import { createSlice } from '@reduxjs/toolkit';

const EnrollSlice = createSlice({
    name: 'EnrollCourse',
    initialState: {
        code: '',
        status: false,
        loading: false,
        discount: 100
    },
    reducers: {
        changeLoading: (state, action) => {
            state.loading = action.payload;
        },
        changeStatus: (state, action) => {
            state.status = action.payload;
        },
        changeDiscount: (state, action) => {
            state.discount = action.payload;
        },
        changeCode: (state, action) => {
            state.code = action.payload;
        },
    }
});
export const {
    changeLoading,
    changeStatus,
    changeDiscount,
    changeCode
} = EnrollSlice.actions;

export default EnrollSlice.reducer;